module.exports = __webpack_public_path__ + "img/tarj-5.1956af25.svg";